import {__} from "./__";

export const getCountryNames = () => {
    return {
        at: __('Rakúsko'),
        be: __('Belgicko'),
        bg: __('Bulharsko'),
        cy: __('Cyprus'),
        cz: __('Česká republika'),
        de: __('Nemecko'),
        dk: __('Dánsko'),
        ee: __('Estónsko'),
        es: __('Španielsko'),
        fi: __('Fínsko'),
        fr: __('Francúzsko'),
        gr: __('Grécko'),
        hr: __('Chorvátsko'),
        hu: __('Maďarsko'),
        ie: __('Írsko'),
        it: __('Taliansko'),
        lt: __('Litva'),
        lu: __('Luxembursko'),
        lv: __('Lotyšsko'),
        mt: __('Malta'),
        nl: __('Holandsko'),
        pl: __('Poľsko'),
        pt: __('Portugalsko'),
        ro: __('Rumunsko'),
        se: __('Švédsko'),
        sl: __('Slovinsko'),
        si: __('Slovinsko'),
        sk: __('Slovensko'),
        en: __('English'),
        all: __('Všetky'),
    };
};
